import { forEachNode } from '../../utils/forEachNode'

export class FrequentQuestions {
    constructor() {
        this.toggleButtons = document.querySelectorAll('.frequent-questions__button');

        forEachNode(
            this.toggleButtons,
            (button) => button.addEventListener(
                'click',
                (event) => this.toggle(event.currentTarget.parentNode, button)
            )
        );
    }

    toggle(option, button) {
        const icon = button.querySelector('.frequent-questions__icon');
        const dropdown = option.querySelector('.frequent-questions__dropdown');
            
        button.classList.toggle('frequent-questions__button_active')
        icon.classList.toggle('frequent-questions__icon_active')
        dropdown.classList.toggle('frequent-questions__dropdown_active')
    }
}
